var _rect, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooksGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_682_11151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_682_11151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77342 0.625C2.03738 0.625 0.625 1.99568 0.625 3.68048C0.625 5.36527 2.03738 6.73596 3.77342 6.73596L5.68281 7.5L8.75 6.73596V0.625H3.77342Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 1.90751C17.1741 1.90751 16.4005 2.71003 16.4005 3.6964C16.4005 4.68277 17.1741 5.48528 18.125 5.48528V6.25H7.58891L6.25 4.51799V2.44284L7.74641 1.25H18.125V1.90751Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.4087V3.125H16.4794C16.6993 2.4014 17.3538 1.875 18.125 1.875H6.92152L6.25 2.4087Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0561 5.59736H8.69806C7.76882 5.59736 7.01285 4.80734 7.01285 3.83632C7.01285 2.86531 7.76886 2.07529 8.69806 2.07529H18.0561C18.4393 2.07529 18.75 1.75064 18.75 1.35015C18.75 0.949654 18.4393 0.625 18.0561 0.625H8.69806C7.00353 0.625 5.625 2.0656 5.625 3.83632C5.625 5.60705 7.00357 7.04765 8.69806 7.04765L13.4167 8.125L16.47 7.04765H18.0561C18.4393 7.04765 18.75 6.72299 18.75 6.3225C18.75 5.92194 18.4393 5.59736 18.0561 5.59736Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2266 6.875H11.25V13.3274L14.6287 14.375L16.2266 13.3274C17.9627 13.3274 19.375 11.8801 19.375 10.1012C19.375 8.32229 17.9627 6.875 16.2266 6.875Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 8.15758C2.8259 8.15758 3.59949 8.96008 3.59949 9.94644C3.59949 10.9328 2.82586 11.7353 1.875 11.7353V12.5H12.4111L13.75 10.768V8.69282L12.2536 7.5H1.875V8.15758Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50891 9.375H13.75V8.65835L13.0781 8.125H1.875C2.64126 8.13125 3.29022 8.65551 3.50891 9.375Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3019 6.875H1.94392C1.56068 6.875 1.25 7.20116 1.25 7.6035C1.25 8.00584 1.56068 8.332 1.94392 8.332H11.3019C12.2312 8.332 12.9872 9.12567 12.9872 10.1012C12.9872 11.0767 12.2311 11.8704 11.3019 11.8704H1.94392C1.56068 11.8704 1.25 12.1965 1.25 12.5989C1.25 13.0012 1.56068 13.3274 1.94392 13.3274H3.53001L5.16238 14.375L11.3019 13.3274C12.9965 13.3274 14.375 11.8801 14.375 10.1012C14.375 8.32226 12.9965 6.875 11.3019 6.875Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77342 19.375C2.03738 19.375 0.625 17.9731 0.625 16.25C0.625 14.5269 2.03738 13.125 3.77342 13.125H8.75V19.375H3.77342V19.375Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.4075C17.1741 14.4075 16.4005 15.2101 16.4005 16.1964C16.4005 17.1828 17.1741 17.9853 18.125 17.9853V18.75H7.58891L6.25 17.018V14.9428L7.74641 13.75H18.125V14.4075Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.375H6.92338L6.25 14.9067V15.625H16.5467C16.7599 14.925 17.3825 14.4093 18.125 14.375Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0561 19.375H8.69806C7.00353 19.375 5.625 17.9731 5.625 16.25C5.625 14.5269 7.00357 13.125 8.69806 13.125H18.0561C18.4393 13.125 18.75 13.4409 18.75 13.8307C18.75 14.2204 18.4393 14.5363 18.0561 14.5363H8.69806C7.76882 14.5363 7.01285 15.3051 7.01285 16.25C7.01285 17.1949 7.76886 17.9637 8.69806 17.9637H18.0561C18.4393 17.9637 18.75 18.2796 18.75 18.6693C18.75 19.0591 18.4393 19.375 18.0561 19.375Z",
    fill: "#9C9C9C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.75C18.1757 20.75 20.75 18.1757 20.75 15C20.75 11.8243 18.1757 9.25 15 9.25C11.8243 9.25 9.25 11.8243 9.25 15C9.25 18.1757 11.8243 20.75 15 20.75Z",
    fill: "#4F95CC",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2424 19.2943C16.3145 18.4826 15.7588 17.3628 15.7588 17.3628C15.7588 17.3628 13.9132 14.2688 13.6633 14.2688C12.1228 13.2492 13.0126 10.4327 13.0178 10.416C11.242 11.1867 10 12.9529 10 15.0082C10 17.6442 12.0425 19.8044 14.6349 19.9993C14.7495 19.7683 14.9384 19.5245 15.2424 19.2943Z",
    fill: "#377CAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5112 17.5C14.3431 17.5 14.1741 17.4475 14.0316 17.34L11.8059 15.1049C11.4623 14.8459 11.3985 14.3636 11.6637 14.0277C11.9287 13.692 12.4222 13.6297 12.7659 13.8887L14.4159 15.6899L17.1311 12.7531C17.422 12.4384 17.9189 12.4138 18.241 12.6982C18.563 12.9825 18.5882 13.4682 18.2972 13.7829L15.0946 17.2469C14.9402 17.4139 14.7264 17.5 14.5112 17.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksGrey);
export default __webpack_public_path__ + "static/media/books_grey.2185025b646520bd39614c48ac6d1d30.svg";
export { ForwardRef as ReactComponent };